import { canViewAgencyFinancials } from "utils/permissionUtils";

/**
 * Cost, the referral fee and the MARA figure a module row keeps in "agreed" are the agency's own
 * money. AccountFinancialRedaction blanks them for a caller without the Accounts or commission
 * key, so an ungated field would offer an empty box that overwrites a real figure on save.
 */
export const AGENCY_MONEY_FIELDS = ["cost", "referral", "agreed"];

/** Takes either plain field keys or {key, label} entries and drops the agency-side ones. */
export const accountFieldsFor = (fields) =>
  canViewAgencyFinancials()
    ? fields
    : fields.filter((field) => !AGENCY_MONEY_FIELDS.includes(field?.key ?? field));
